import * as React from "react";
import Images from "../../Assets/Images";

 const WorkStreamCommandCell = props => {
  const { dataItem } = props;
  const inEdit = dataItem[props.editField];
  const isNewItem = props.currentComponent==='WorkStreamType'? dataItem.id === undefined:dataItem.id === undefined;

  return inEdit ? (
    <td className="k-command-cell">
      <ul className="actionIcon">
        <li>
          <a title="Add" href="#" className="greenbtn  icon" onClick={() => (isNewItem ? props.add(dataItem) : props.update(dataItem))}>
            <img src={Images.CHECKGREEN} width="10" alt="Edit"/>
          </a>
        </li>
        <li>
          <a title="Cancel" href="#" className="redbtn icon"  onClick={() => (isNewItem ? props.discard(dataItem) : props.cancel(dataItem))}>
            <img src={Images.DELETE} width="10" alt="Cancel"/>
          </a>
        </li>
      </ul>
    </td>
  ) : (
    <td className="k-command-cell">
      <ul className="actionIcon">
        <li>
          <a title="Edit" href="#" className="greenbtn  icon" onClick={() => props.edit(dataItem)}>
            <img src={Images.EDITICON} width="10" alt="Edit"/>
          </a>
        </li>
        <li>
          <a title="Delete" href="#" className="redbtn icon"  onClick={() =>
          // confirm("Confirm deleting: " + dataItem.ProductName) &&
          props.handledelete(dataItem)
        }>
            <img src={Images.TRASH} width="12" alt="Cancel"/>
          </a>
        </li>
      </ul>
    </td>
  );
};


export default WorkStreamCommandCell
